<template>
  <section id="overview">
    <div class="max-w-screen-2xl mx-auto px-4 flex flex-wrap py-12 my-6">
      <div class="w-full md:w-6/12 pt-10 md:pr-20 overview">
        <h2 class="font-secondary text-2xl md:text-3xl mb-8">
          {{ tr("Overview") }}
        </h2>
        <div class="mb-8 text-lg pl-4">
          <ul>
            <li class="list-disc text-primary" v-if="dayList && dayList.length">
              <span class="uppercase text-primary font-bold">Duration: </span
              ><span class="uppercase text-black">{{ dayLength }} days</span>
            </li>
            <li class="list-disc text-primary" v-if="!noDateView">
              <span class="uppercase text-primary font-bold">Arrival: </span
              ><span class="uppercase text-black">{{ arrivalDate }}</span>
            </li>
            <li class="list-disc text-primary" v-if="!noDateView">
              <span class="uppercase text-primary font-bold">Departure: </span
              ><span class="uppercase text-black">{{ departureDate }}</span>
            </li>
            <li class="list-disc text-primary" v-else>
              <span class="uppercase text-primary font-bold">{{
                tr("Date to be confirmed")
              }}</span>
            </li>
            <li class="list-disc text-primary">
              <span class="uppercase text-primary font-bold"
                >Destinations:
              </span>
              <span class="uppercase text-black" v-if="bookinglocations">{{
                bookinglocations.join(", ")
              }}</span>
            </li>
          </ul>
        </div>
        <div
          class="flex text-dark font-normal text-md mb-2"
          v-for="(day, index) of dayList"
          :key="index"
        >
          <span class="uppercase font-bold inline-block mr-2 w-4/12"
            ><span class="mr-5">DAY {{ day.dayNr }}</span>
            <span v-if="!noDateView">{{ day.date }}</span></span
          >
          <div class="w-10/12 flex flex-col" v-if="titles && titles[index]">
            <span
              class="font-light"
              v-for="(title, ti) of titles[index]"
              :key="'ti-' + ti"
            >
              {{ title }}.
            </span>
          </div>
        </div>
        <span class="mt-2">* {{ totalNights }} {{ tr("hotel nights included (find the details in the 'Included' section at the bottom of this itinerary).") }}</span>
      </div>
      <div
        class="w-full md:w-6/12"
        v-if="services && bookingCities && bookingCities.length"
      >
        <div class="overflow-hidden rounded-xl maps-container" id="mapDiv">
          <GoogleMap
            id="mainMap"
            ref="mainMap"
            :bookingCities="bookingCities"
          ></GoogleMap>
          <GoogleMap
            :class="{ 'overlay-top': !hasPeru, 'overlay-bottom': hasPeru }"
            v-if="hasPascua"
            :small="true"
            id="smallMap"
            :bookingCities="bookingCities"
          ></GoogleMap>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import * as _ from "lodash";
//var moment = require('moment');
import GoogleMap from "@/components/itinerary/GoogleMap.vue";
const api = window.api;
export default {
  name: "TripOverview",
  props: {},
  data() {
    return {
      maps: false,
    };
  },
  components: {
    GoogleMap,
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.mainMap) this.maps = true;
    });
  },
  asyncComputed: {
    async titles() {
      let titles = {};
      if (this.dayList && this.dayList.length) {
        for (let j = 0; j < this.dayList.length; j++) {
          titles[j] = {};
          let day = this.dayList[j];
          for (let i = 0; i < day.services.length; i++) {
            if (!day.services[i]) continue;
            const replaceNote = this.$store.getters.replaceNote(
              day.services[i].code,
              day.services[i].day,
            );
            if (!day.services[i].title && !replaceNote?.title) continue;
            let res = await api.extractText(
              replaceNote?.title || day.services[i].title,
            );
            if (res) {
              titles[j][i] = res;
            }
          }
        }
      }
      return titles;
    },
    allServices() {
      return this.$store.state.allServices;
    },
    services() {
      return this.$store.getters.serviceStatusList();
    },
    bookingCities() {
      return this.$store.getters.bookingCities;
    },
    hasPascua() {
      if (!this.bookingCities) return false;
      return _.find(this.bookingCities, (r) => r.Longitude < -100);
    },
    hasPeru() {
      if (this.maps) {
        if (this.$refs.mainMap.hasPeru) return true;
      }
      return false;
    },
    dayList() {
      return this.$store.getters.dayList;
    },
    noDateView() {
      return this.$store.state.noDateView;
    },
    hotels() {
      return this.$store.state.hotels;
    },
  },
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
    formatDate(dateString) {
      const fechaObj = new Date(dateString);

      const opciones = {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "UTC",
      };
      const codeLang = {
        SP: "es-ES",
        EN: "en-GB",
        DE: "de-DE",
      };
      let res = fechaObj.toLocaleDateString(codeLang[this.lang], opciones);

      return res;
    },
  },
  computed: {
    arrivalDate() {
      if (!this.dayList || !this.dayList.length) return "";
      return this.formatDate(this.dayList[0]?.dateString);
    },
    departureDate() {
      if (!this.dayList || !this.dayList.length) return "";
      return this.formatDate(this.dayList[this.dayList.length - 1]?.dateString);
    },
    lang() {
      return this.$store.state.lang;
    },
    bookinglocations() {
      if (!this.allServices) return [];
      let locations = this.allServices.reduce((acc, service) => {
        if (service.LocationName) {
          acc.push(service.LocationName.toUpperCase());
        }
        return acc;
      }, []);
      return [...new Set(locations)];
    },
    totalNights() {
      return this.$store.getters.totalHotelNights;
    },
    dayLength() { 
      if (!this.dayList) return 0;
      let services = this.allServices.filter(
        (s) => !["3004", "INFO"].includes(s.SupplierCode.trim()),
      );
      let servicesIncludes = new Set();
      services.forEach((service) => {
        servicesIncludes.add(service.date);
      });

      const toISODate = (dateValue) => {
        if (!dateValue) return null;
        if (typeof dateValue === "string" && dateValue.length >= 10) {
          return dateValue.slice(0, 10);
        }
        return new Date(dateValue).toISOString().split("T")[0];
      };

      const toDateTimeString = (dateObj) => {
        const year = dateObj.getUTCFullYear();
        const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getUTCDate()).padStart(2, "0");
        return `${year}-${month}-${day}T00:00:00`;
      };

      let hotels = _.filter(this.hotels, (h) => h?.SupplierCode?.trim() != '3004' && h?.LocationCode != '000');
      (hotels || []).forEach((hotel) => {
        const checkIn = toISODate(hotel.CheckIn);
        const checkOut = toISODate(hotel.CheckOut);
        if (!checkIn || !checkOut) return;

        let currentDate = new Date(`${checkIn}T00:00:00Z`);
        const endDate = new Date(`${checkOut}T00:00:00Z`);

        while (currentDate < endDate) {
          servicesIncludes.add(toDateTimeString(currentDate));
          currentDate.setUTCDate(currentDate.getUTCDate() + 1);
        }
      });
      // services = services.sort((a, b) => new Date(a.date) - new Date(b.date));
      // const firstDate = new Date(services[0].date);
      // const lastDate = new Date(services[services.length - 1].date);
      // const diffTime = Math.abs(lastDate - firstDate);
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      return servicesIncludes.size;
    },
  },
};
</script>

<style scoped>
.overview {
  padding-top: 0px;
}

.maps-container {
  position: relative;
}
.overlay-bottom {
  position: absolute;
  bottom: 0%;
  left: 0;
  width: 30%;
  height: 4rem;
}
.overlay-top {
  position: absolute;
  top: 0%;
  left: 0;
  width: 25%;
  height: 4rem;
}
</style>
